import {
  DataProductEntity,
  DataProductFormData,
  Tag,
  TagForm,
} from 'v2/DataProducts/models';
import { FilterEntityOption } from 'v2/models';

export const TAG_FIELDS = [
  'sector',
  'metric',
  'entity',
  'geography',
  'source_type',
  'delivery_format',
];

export const DATA_PRODUCT_DELIVERY_FORMATS = [
  { id: 1, label: 'API' },
  { id: 2, label: 'CSV' },
  { id: 3, label: 'GUI' },
  { id: 4, label: 'S3 Bucket' },
  { id: 5, label: 'Snowflake' },
];

export const DATA_PRODUCT_DEFAULT_VALUES: DataProductFormData = {
  name: '',
  description: '',
  sector: [],
  metric: [],
  entity: [],
  geography: [],
  source_type: [],
  pricemin: null,
  pricemax: null,
  lag_in_days: null,
  history_in_months: null,
  delivery_format: [],
  prompt_history_id: undefined,
};

// Array to configure labels and order to show data product data.
export const DATA_PRODUCT_LABEL = [
  {
    sector: 'Sector',
  },
  {
    metric: 'Metrics',
  },
  { entity: 'Entities' },
  { geography: 'Geographies' },
  { source_type: 'Source Types' },
  { priceRange: 'Price Range' },
  { lag_in_days: 'Lag' },
  { history_in_months: 'History' },
  { delivery_format: 'Delivery Formats' },
];

export function getSortedDataProductBadgeData(data: DataProductEntity) {
  const parsedDataTags: { [key: string]: string[] } = {};
  for (const tag of data.data_tags) {
    parsedDataTags[tag.type] = [...(parsedDataTags[tag.type] || []), tag.value];
  }

  return DATA_PRODUCT_LABEL.map((item) => {
    const key = Object.keys(item)[0];
    const label = Object.values(item)[0];
    let dataTagStr;
    if (key === 'delivery_format') {
      dataTagStr = (parsedDataTags[key] || [])
        .map((format) => findDatFormat(format.toLowerCase())?.label)
        .join(', ');
    } else {
      dataTagStr =
        parsedDataTags[key]?.join(', ') ||
        (data[key as keyof DataProductEntity] as string | number);
    }
    return {
      label: label,
      data: dataTagStr,
    };
  });
}

/**
 *
 * @param dataTags Data returned by BE
 * @returns Data transformed to be compatible with the form to edit.
 */
export function parseDataTagsToEdit(dataTags: Tag[]): DataProductFormData {
  const tags = TAG_FIELDS.reduce(
    (acc, item) => ({
      ...acc,
      [item]: [],
    }),
    {}
  );
  const parsedTagsData = dataTags.reduce(
    (
      acc: { [key: string]: Array<TagForm | FilterEntityOption> },
      item: Tag
    ) => {
      if (item.type === 'delivery_format') {
        return {
          ...acc,
          [item.type]: [
            ...(acc[item.type] || []),
            { id: item.value, name: item.value },
          ],
        };
      } else {
        return {
          ...acc,
          [item.type]: [...(acc[item.type] || []), { value: item.value }],
        };
      }
    },
    tags
  );

  return parsedTagsData as DataProductFormData;
}

export function parsedDataToDisplay(
  data: DataProductFormData
): DataProductFormData {
  return {
    ...data,
    delivery_format: data.delivery_format
      .map((item) => {
        const matchedFormat = findDatFormat(item.name.toLowerCase());
        if (matchedFormat) {
          return {
            id: matchedFormat?.label,
            name: matchedFormat?.label,
          };
        }
        return undefined;
      })
      .filter(Boolean) as DataProductFormData['delivery_format'],
  };
}

function findDatFormat(str: string) {
  return DATA_PRODUCT_DELIVERY_FORMATS.find(
    (format) => format.label.toLowerCase() === str.toLowerCase()
  );
}
